import { render, staticRenderFns } from "./ConfigurarAlertasPantalla.vue?vue&type=template&id=5b1215e0&"
import script from "./ConfigurarAlertasPantalla.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarAlertasPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports